import { useNavigate } from 'react-router-dom';
import { useAuth } from '@practium/features/auth';
import { ConfigCard } from '../components/ConfigCard/ConfigCard';
import { ConfigCardSection } from '../components/ConfigCardSection/ConfigCardSection';
import styles from './SettingsPage.module.css';
import { useState } from 'react';

const QUICK_FILTERS = [
	'Mensagens de aniversário',
	'Notificações no e-mail',
	'Notificações no WhatsApp',
];

export const SettingsPage = () => {
	const [selectedFilter, setSelectedFilter] = useState<string>('Mensagens de aniversário');
	const { user } = useAuth();
	const navigate = useNavigate();
	const firstName = user?.name?.split(' ')[0] ?? 'Admin';

	function handleSelectedFilter(filter: string) {
		setSelectedFilter(filter);
	}

	return (
		<div className={styles.page}>
			<div className={styles.header}>
				<div className={styles.pageTitle}>
					<h1 className={styles.greeting}>Olá, {firstName}</h1>
					<p className={styles.subtitle}>Deseja configurar o que hoje?</p>
				</div>
				<div className={styles.badges}>
					{QUICK_FILTERS.map((label) => (
						<button
							key={label}
							onClick={() => {
								handleSelectedFilter(label);
							}}
							className={selectedFilter == label ? styles.selectedBadge : styles.badge}
						>
							{label}
						</button>
					))}
				</div>
			</div>

			<ConfigCardSection>
				<ConfigCard
					title="Cores & Design do Practium"
					variant="gradient"
					decorativeText={['AZ', 'UL']}
					onConfigure={() => navigate('/configuracoes/design')}
				/>
				<ConfigCard
					title="Planos & Depoimentos Landing Page"
					variant="image"
					imageUrl="/images/carousel-slide-2.jpg"
					onConfigure={() => navigate('/configuracoes/landing')}
				/>
				<ConfigCard
					title="Banners Home Page"
					variant="image"
					imageUrl="/images/carousel-slide-1.jpg"
					onConfigure={() => {}}
				/>
				<ConfigCard
					title="Gateways de Pagamento"
					variant="gradient"
					decorativeText={['GW']}
					onConfigure={() => navigate('/configuracoes/gateways')}
				/>
			</ConfigCardSection>
		</div>
	);
};
